import React from "react"
import { MdCheckCircle, MdWarning } from "react-icons/md"
import styled from "styled-components"

import {
	MobergFontFamily,
	MobergFontSize,
} from "../../../../../Components/MobergFont/MobergFont"

export interface CalibrationStatusDetails {
	state: "success" | "warning"
	title: string
	desc: string
}

export const CalibrationStatusBanner: React.FC<{ details: CalibrationStatusDetails }> = ({
	details,
}) => {
	const colors = bannerPalette[details.state]
	return (
		<Banner $state={details.state}>
			<div style={{ color: colors.icon, paddingTop: "2px" }}>
				{details.state === "success" ? (
					<MdCheckCircle size={18} />
				) : (
					<MdWarning size={18} />
				)}
			</div>
			<div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
				<div
					style={{
						fontFamily: MobergFontFamily.HEADER,
						fontSize: MobergFontSize.LARGE,
						fontWeight: "600",
						color: colors.title,
					}}
				>
					{details.title}
				</div>
				<div
					style={{
						fontSize: MobergFontSize.REGULAR,
						color: colors.desc,
						lineHeight: "1.45",
					}}
				>
					{details.desc}
				</div>
			</div>
		</Banner>
	)
}

const bannerPalette = {
	success: {
		background: "rgba(76, 175, 80, 0.15)",
		border: "#4CAF50",
		icon: "#4CAF50",
		title: "var(--color-text-primary)",
		desc: "var(--text-secondary-color)",
	},
	warning: {
		background: "rgba(255, 152, 0, 0.15)",
		border: "#FF9800",
		icon: "#FF9800",
		title: "var(--color-text-primary)",
		desc: "var(--text-secondary-color)",
	},
} as const

const Banner = styled.div<{ $state: "success" | "warning" }>`
	display: flex;
	align-items: flex-start;
	gap: 12px;
	width: 100%;
	padding: 16px 18px;
	border-radius: 4px;
	border: 1px solid ${({ $state }) => bannerPalette[$state].border};
	background: ${({ $state }) => bannerPalette[$state].background};
	font-family: ${MobergFontFamily.REGULAR};
`
